import { chain, map, zipObj } from 'ramda';

// NOTE: https://github.com/ramda/ramda/wiki/Cookbook#make-an-object-out-of-a-list-with-keys-derived-form-each-element
export const objFromListWith = <TItem>(
	fn: (item: TItem) => string,
	list: TItem[]
): Record<string, TItem> => chain<any, any, any>(zipObj, map(fn))(list);
